import React from 'react'
const FONT_SIZE = 13
const ItemKanban = ({ classCol, label, value }) => (
    <div className={classCol}>
        <p className="card-text mb-0" style={{ fontSize: FONT_SIZE }}><strong>{label} </strong></p>
        <p className="card-text mb-1 text-truncate" style={{ fontSize: FONT_SIZE }}>{value}</p>
    </div>
)

export { ItemKanban }